"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLoading = _interopRequireDefault(require("react-loading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Loader = () => _react.default.createElement(_reactLoading.default, {
  type: "spinningBubbles",
  width: 18,
  height: 18,
  color: "#ffffff"
});

var _default = Loader;
exports.default = _default;